import { render, staticRenderFns } from "./LibertyKidsRetornoEB.vue?vue&type=template&id=364875f3&scoped=true"
import script from "./LibertyKidsRetornoEB.vue?vue&type=script&lang=js"
export * from "./LibertyKidsRetornoEB.vue?vue&type=script&lang=js"
import style0 from "./LibertyKidsRetornoEB.vue?vue&type=style&index=0&id=364875f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364875f3",
  null
  
)

export default component.exports